import React from 'react';
import styled from '@tanium/react-emotion';
import { Stack, StackChild } from '@tanium/react-stack';

export interface Props {
  children: React.ReactNode;
  sideContent?: React.ReactNode;
  dividers?: boolean;
}

const SideContentContainer = styled('div')({ padding: '16px 0' });

/**
 * A container for holding multiple, potentially nested, sections. Used to hold section content for
 * components like Configuration.
 */
export const SectionContainer = ({ children, sideContent, dividers = false }: Props) => (
  <Stack component="section" itemSpacing={4} itemDividers>
    <StackChild
      grow={1}
      // basis="100%" is for IE11
      basis="100%"
    >
      <Stack direction="column" itemSpacing={4} itemDividers={dividers}>
        {children}
      </Stack>
    </StackChild>
    {sideContent && (
      <StackChild component={SideContentContainer} shrink={0} basis={320}>
        {sideContent}
      </StackChild>
    )}
  </Stack>
);
